import square from '../../assets/propic-square.jpg';
import round from '../../assets/propic-round.png';

import '../../styles/days.scss';

const Seventeen = () => (
  <div className='days Seventeen'>
    <img src={square} className='square' alt='square pic' />
    <img src={round} className='round' alt='round pic' />
  </div>
);

export default Seventeen;
